"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConduitController__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "CallerIsNotNewPotentialOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "CallerIsNotOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "ChannelOutOfRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "ConduitAlreadyExists",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCreator",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                internalType: "address",
                name: "newPotentialOwner",
                type: "address",
            },
        ],
        name: "NewPotentialOwnerAlreadySet",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "NewPotentialOwnerIsZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NoConduit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "NoPotentialOwnerCurrentlySet",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "conduitKey",
                type: "bytes32",
            },
        ],
        name: "NewConduit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newPotentialOwner",
                type: "address",
            },
        ],
        name: "PotentialOwnerUpdated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "cancelOwnershipTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "conduitKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "createConduit",
        outputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "channelIndex",
                type: "uint256",
            },
        ],
        name: "getChannel",
        outputs: [
            {
                internalType: "address",
                name: "channel",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                internalType: "address",
                name: "channel",
                type: "address",
            },
        ],
        name: "getChannelStatus",
        outputs: [
            {
                internalType: "bool",
                name: "isOpen",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "getChannels",
        outputs: [
            {
                internalType: "address[]",
                name: "channels",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "conduitKey",
                type: "bytes32",
            },
        ],
        name: "getConduit",
        outputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                internalType: "bool",
                name: "exists",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getConduitCodeHashes",
        outputs: [
            {
                internalType: "bytes32",
                name: "creationCodeHash",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "runtimeCodeHash",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "getKey",
        outputs: [
            {
                internalType: "bytes32",
                name: "conduitKey",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "getPotentialOwner",
        outputs: [
            {
                internalType: "address",
                name: "potentialOwner",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "getTotalChannels",
        outputs: [
            {
                internalType: "uint256",
                name: "totalChannels",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                internalType: "address",
                name: "newPotentialOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
            {
                internalType: "address",
                name: "channel",
                type: "address",
            },
            {
                internalType: "bool",
                name: "isOpen",
                type: "bool",
            },
        ],
        name: "updateChannel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ConduitController__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ConduitController__factory = ConduitController__factory;
ConduitController__factory.bytecode = _bytecode;
ConduitController__factory.abi = _abi;
//# sourceMappingURL=ConduitController__factory.js.map